import userByOriginsModule from "./userByOriginsModule"
import tdnSpecification from "../r2/tdnSpecification.json"

userByOriginsModule.controller("userByOriginsController", ["$scope", "$translate", "userByOriginsService", "remoteExceptionHandler", "loadingService", "messagesModal", ($scope, $translate, userByOriginsService, remoteExceptionHandler, loadingService, messagesModal) => {

    $scope.tdn = tdnSpecification["users-by-origin"]

    $scope.availableOrigins = []
    $scope.userByOrigins = {
        user: {},
        origins: []
    }

    $scope.save = function () {
        loadingService(userByOriginsService.save($scope.userByOrigins))
            .catch(remoteExceptionHandler())
            .then(() => messagesModal("dialog.success", "entity.validator.successMessage"))
    }

    $scope.search = function (patch) {
        loadingService(userByOriginsService.userByOrigins(patch))
            .then((response) => {
                $scope.userByOrigins.origins = response.result[0].origins
                $scope.userByOrigins.user = response.result[0].user
            })
            .then(() => {
                userByOriginsService.findAllOrigins().then((origins) => {
                    $scope.availableOrigins = origins
                })
            })
    }

    $scope.getPanelBundle = function () {
        if (! $scope.userByOrigins.user.name ) {
            return $translate.instant("userByOrigins.user")
        }
        return $translate.instant("userByOrigins.user") + $scope.userByOrigins.user.name
    }
}])